import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';
import FormUsuario from './FormUsuario';

export default function PaginaUsuario() {
  const { publicId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  const ehNovo = !publicId;
  const [usuarioAlvo, setUsuarioAlvo] = useState(null);
  const [carregando, setCarregando] = useState(!ehNovo);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (ehNovo) return;
    api
      .get(`/usuarios/${publicId}`)
      .then((r) => setUsuarioAlvo(r.data))
      // Achado em auditoria 2026-09-18: sem `.catch`, uma falha deixava
      // `usuarioAlvo` em `null` — e como `FormUsuario` decidia "é
      // criação?" checando `!usuarioInicial`, a tela de EDIÇÃO virava
      // "criação" na prática (mostrava seletor de Nível e aviso de senha
      // "123mudar", e salvava via POST em vez de PUT). Agora `ehNovo` é
      // uma prop explícita (vem do `publicId` da URL, nunca do dado
      // carregado) — ver FormUsuario.js.
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar o usuário');
      })
      .finally(() => setCarregando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId, ehNovo]);

  async function salvar(dados) {
    if (ehNovo) {
      const empresaId = searchParams.get('empresa_id');
      if (empresaId) dados.empresa_id = empresaId;
      await api.post('/usuarios', dados);
      toast.sucesso('Usuário criado com sucesso.');
    } else {
      await api.put(`/usuarios/${publicId}`, dados);
      toast.sucesso('Usuário atualizado com sucesso.');
    }
    navigate('/usuarios');
  }

  return (
    <>
      <h1 className="h4 mb-4">{ehNovo ? 'Novo usuário' : 'Editar usuário'}</h1>
      {carregando ? (
        <Spinner animation="border" />
      ) : (
        !erro && (
          <FormUsuario
            ehNovo={ehNovo}
            usuarioInicial={usuarioAlvo}
            empresaIdPreSelecionada={searchParams.get('empresa_id')}
            aoSalvar={salvar}
          />
        )
      )}
    </>
  );
}
